import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DeleteAllEgressEventMappingPayload, DeleteEgressEventMappingOfIngressPayload, DeleteEgressEventMappingPayload, EgressEventMappingPayload, EgressEventMappingState, UpdateEgressEventMappingPayload } from '../../actions/types/services/EgressEventsMappingTypes';

/**
 * Initial Ingress Events in the store
 */
const initialState: EgressEventMappingState = {
  egressEventMappingList: [],
};

const egressEventMappingSlice = createSlice({
  name: 'egressEventMapping',
  initialState,
  reducers: {
    addEgressEventMapping: (
      state,
      actions: PayloadAction<EgressEventMappingPayload>
    ) => {
      state.egressEventMappingList.push(actions.payload.egressEventMapping);
    },
    addAllEgressEventMapping: (
      state,
      actions: PayloadAction<EgressEventMappingState>
    ) => {
      state.egressEventMappingList = [...actions.payload.egressEventMappingList];
    },
    addEgressEventMappingList: (
      state,
      actions: PayloadAction<EgressEventMappingState>
    ) => {
      state.egressEventMappingList = [...state.egressEventMappingList, ...actions.payload.egressEventMappingList];
    },
    deleteEgressEventMapping: (state, actions: PayloadAction<DeleteEgressEventMappingPayload>) => {
      const itemIndex = state.egressEventMappingList.findIndex((item) => item.serviceOperationName === actions.payload.serviceOperationName && item.eventName === actions.payload.eventName
        && item.ingressName === actions.payload.ingressName && item.eventVersion === actions.payload.eventVersion && item.ingressEventVersion === actions.payload.ingressEventVersion);
      state.egressEventMappingList.splice(itemIndex > 0 ? itemIndex : 0, 1);
    },

    deleteAllEgressEventMapping: (state, actions: PayloadAction<DeleteAllEgressEventMappingPayload>) => {
      const itemIndex = state.egressEventMappingList.findIndex((item) => item.serviceOperationName === actions.payload.serviceOperationName);
      state.egressEventMappingList.splice(itemIndex > 0 ? itemIndex : 0, 1);
    },

    deleteEgressEventMappingOfIngress: (state, actions: PayloadAction<DeleteEgressEventMappingOfIngressPayload>) => {
      state.egressEventMappingList = state.egressEventMappingList.filter((item) => !(item.serviceOperationName === actions.payload.serviceOperationName && item.ingressName === actions.payload.ingressEventName && item.ingressEventVersion === actions.payload.ingressEventVersion));
    },

    updateEgressEventMapping: (state, actions: PayloadAction<UpdateEgressEventMappingPayload>) => {
      state.egressEventMappingList.splice(actions.payload.editIndex, 1, actions.payload.egressEventMapping);
    },

    clearEgressEventMapping: (state) => {
      state.egressEventMappingList = initialState.egressEventMappingList;
    },
  }
});
export const {
  addEgressEventMapping,
  addAllEgressEventMapping,
  addEgressEventMappingList,
  deleteEgressEventMapping,
  deleteAllEgressEventMapping,
  deleteEgressEventMappingOfIngress,
  updateEgressEventMapping,
  clearEgressEventMapping,

} = egressEventMappingSlice.actions;
export default egressEventMappingSlice.reducer;
